/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/SideBar',['pixi', 'absolute', 'lodash', 'MenuUI/CustomButton', 'Managers/ScaleManager'],

    function (PIXI, Absolute, _, CustomButton, ScaleManager) {

        var SideBar = function (options) {
            this.handleGraphics = null;
            this.handleHeldGraphics = null;
            this.arrowHoldInterval = null;
            this.handleHoldInterval = null;
            this.arrowIsHeldDown = false;
            this.handleIsHeldDown = false;
            this.currentScrollPercent = 0;
            this.arrowSize = Absolute.Coords.y(20);
            this.handleHeight = null;
            this.partialHeight = options.partialHeight - (2 * this.arrowSize) || 100;
            this.availableHeight = options.availableHeight - (2 * this.arrowSize) || 200;
            this.visualHeight = options.visualHeight - (2 * this.arrowSize) || 300;
            this.initialize(options);
        };

        SideBar.constructor = SideBar;
        SideBar.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        SideBar.prototype.initialize = function (options) {
            PIXI.DisplayObjectContainer.call(this);
            this.options = options;
            this.initBackground();
            this.initButtons();
            this.initSlider();
        };

        SideBar.prototype.resetDimensions = function (partialHeight, availableHeight, onScrollUpdate, visualHeight) {
            this.partialHeight = partialHeight - (2 * this.arrowSize);
            this.availableHeight = availableHeight - (2 * this.arrowSize);
            this.visualHeight = visualHeight - (2 * this.arrowSize);
            this.resetBackground();
            this.resetButtons();
            this.resetSlider();
            this.options.onScrollUpdate = onScrollUpdate;
        };

        SideBar.prototype.setListenersForHandleInteraction = function (onHandleDown, onHandleUp) {
            this.onHandleDown = onHandleDown;
            this.onHandleUp = onHandleUp;
        };

        SideBar.prototype.initButtons = function () {
            this.upButton = new CustomButton({
                up: 'sidebar/arrow-up.png',
                over: 'sidebar/arrow-over.png',
                down: 'sidebar/arrow-down.png',
                action: {
                    down: this.handleArrowTopDown.bind(this),
                    up: this.handleArrowTopUp.bind(this)
                }
            });
            this.downButton = new CustomButton({
                up: 'sidebar/arrow-up.png',
                over: 'sidebar/arrow-over.png',
                down: 'sidebar/arrow-down.png',
                action: {
                    down: this.handleArrowBottomDown.bind(this),
                    up: this.handleArrowBottomUp.bind(this)
                }
            });
            this.downButton.rotation = Math.PI;
            this.upButton.position.set(0, 0);
            this.downButton.position.set(this.arrowSize, this.visualHeight + (2 * this.arrowSize));
            this.addChild(this.upButton);
            this.addChild(this.downButton);
        };

        SideBar.prototype.resetBackground = function() {
            this.background.clear();
            this.drawBackground();
        };

        SideBar.prototype.resetButtons = function() {
            this.downButton.position.set(this.arrowSize, this.visualHeight + (2 * this.arrowSize));
        };

        SideBar.prototype.resetSlider = function() {
            this.handleGraphics.clear();
            this.handleHeldGraphics.clear();
            this.drawHandleGraphics();
            this.updateHandleByPercent(this.currentScrollPercent);
        };

        SideBar.prototype.initBackground = function () {
            this.background = new PIXI.Graphics();
            this.addChild(this.background);
            this.drawBackground();
        };

        SideBar.prototype.initSlider = function () {
            this.handleGraphics = new PIXI.Graphics();
            this.handleHeldGraphics = new PIXI.Graphics();
            this.addChild(this.handleGraphics);
            this.handleGraphics.addChild(this.handleHeldGraphics);
            this.drawHandleGraphics();
            this.updateHandleByPercent(this.currentScrollPercent);
        };

        SideBar.prototype.drawBackground = function () {
            this.background.beginFill(0x000000, 1);
            this.background.drawRect(0, this.arrowSize, this.arrowSize, this.visualHeight);
            this.background.endFill();
            this.background.interactive = true;
            this.background.mousedown = function(evt) {
                var isLowerHalf = (evt.global.y < ((ScaleManager.height * this.parent.scale.y) / 2));
                this.updateScrollPercent(isLowerHalf ? 0 : 100);
                this.updateHandleByPercent(isLowerHalf ? 0 : 100);
            }.bind(this);
            this.background.touchstart = function(evt) {
                var isLowerHalf = (evt.global.y < ((ScaleManager.height * this.parent.scale.y) / 2));
                this.updateScrollPercent(isLowerHalf ? 0 : 100);
                this.updateHandleByPercent(isLowerHalf ? 0 : 100);
            }.bind(this);
        };

        SideBar.prototype.drawHandleGraphics = function () {
            var screenPercentInTarget = (100 * this.availableHeight) / this.partialHeight,
                handleHeight = (this.visualHeight * screenPercentInTarget) / 100;
            this.handleHeight = handleHeight;
            this.handleGraphics.y = this.arrowSize;
            this.handleGraphics.beginFill(0x474747);
            this.handleGraphics.drawRect(0, 0, this.arrowSize, handleHeight);
            this.handleHeldGraphics.beginFill(0x919090);
            this.handleHeldGraphics.drawRect(0, 0, this.arrowSize, handleHeight);
            this.handleHeldGraphics.visible = false;
            this.handleGraphics.interactive = true;
            this.handleGraphics.mouseover = function (evt) {
            }.bind(this);
            this.prevPos = null;
            var dy = 0;
            if (Absolute.Platform.supportsTouch()) {
                this.handleGraphics.touchstart = function(data) {
                    this.dragEnabled = true;
                    this.handleHandleInputDown();
                }.bind(this);
                this.handleGraphics.touchmove = function(data) {
                    if(this.dragEnabled) {
                        dy = this.prevPos ? this.prevPos - data.global.y : 0;
                        this.prevPos = data.global.y;
                        this.handleGraphics.y -= dy / this.parent.scale.y;
                        if(this.handleGraphics.y + handleHeight > this.arrowSize + this.visualHeight) {
                            this.handleGraphics.y = this.arrowSize + this.visualHeight - handleHeight;
                        }
                        if(this.handleGraphics.y <= this.arrowSize) {
                            this.handleGraphics.y = this.arrowSize;
                        }
                    }
                }.bind(this);
                this.handleGraphics.touchend = function(data) {
                    this.dragEnabled = false;
                    this.handleHandleInputUp();
                }.bind(this);
                this.handleGraphics.touchendoutside = function(data) {
                    this.dragEnabled = false;
                    this.handleHandleInputUp();
                }.bind(this);
            }
            this.handleGraphics.mousemove = function (data) {
                if(this.dragEnabled) {
                    dy = this.prevPos ? this.prevPos - data.originalEvent.y : 0;
                    this.prevPos = data.originalEvent.y;
                    this.handleGraphics.y -= dy;
                    if(this.handleGraphics.y + handleHeight > this.arrowSize + this.visualHeight) {
                        this.handleGraphics.y = this.arrowSize + this.visualHeight - handleHeight;
                    }
                    if(this.handleGraphics.y <= this.arrowSize) {
                        this.handleGraphics.y = this.arrowSize;
                    }
                }
            }.bind(this);
            this.handleGraphics.mouseout = function (evt) {
            }.bind(this);
            this.handleGraphics.mousedown = function (evt) {
                this.dragEnabled = true;
                this.handleHandleInputDown();
            }.bind(this);

            this.handleGraphics.mouseup = function (evt) {
                this.dragEnabled = false;
                this.handleHandleInputUp();
            }.bind(this);

            this.handleGraphics.mouseupoutside = function (evt) {
                this.dragEnabled = false;
                this.handleHandleInputUp();
            }.bind(this);
        };

        SideBar.prototype.checkAndClearHandleHoldInterval = function () {
            if (this.handleIsHeldDown) {
                clearInterval(this.handleHoldInterval);
                this.handleIsHeldDown = false;
            }
        };

        SideBar.prototype.handleHandleInputUp = function () {
            this.prevPos = null;
            this.handleHeldGraphics.visible = false;
            this.checkAndClearHandleHoldInterval();
            if (this.onHandleUp) this.onHandleUp();
        };

        SideBar.prototype.updateScrollPercent = function (newValue) {
            if (newValue > 100) newValue = 100;
            if (newValue < 0) newValue = 0;
            this.currentScrollPercent = newValue;
            this.options.onScrollUpdate(this.currentScrollPercent);
        };

        SideBar.prototype.updateHandleByPercent = function(percent) {
            var mathStuff = this.visualHeight - this.handleHeight;
            this.handleGraphics.y = (((mathStuff) * percent) / 100) + this.arrowSize;
            this.currentScrollPercent  = ((this.handleGraphics.y - this.arrowSize) / mathStuff) * 100;
        };

        SideBar.prototype.updateByHandle = function () {
            this.handleGraphics.updateTransform();
            var handleY = this.handleGraphics.y;
            var mathStuff = this.visualHeight - this.handleHeight;
            this.updateScrollPercent(((handleY - this.arrowSize) / mathStuff) * 100);
        };

        SideBar.prototype.setUpHandleUpdateInterval = function () {
            this.handleIsHeldDown = true;
            this.updateByHandle();
            this.handleHoldInterval = setInterval(function() {
                this.updateByHandle();
            }.bind(this), 5);
        };

        SideBar.prototype.handleHandleInputDown = function () {
            this.handleHeldGraphics.visible = true;
            this.setUpHandleUpdateInterval();
            if (this.onHandleDown) this.onHandleDown();
        };

        SideBar.prototype.handleArrowTopDown = function() {
            this.setUpArrowUpdateInterval(-1);
        };

        SideBar.prototype.handleArrowBottomDown = function() {
            this.setUpArrowUpdateInterval(1);
        };

        SideBar.prototype.handleArrowTopUp = function() {
            this.checkAndClearArrowHoldInterval();
        };

        SideBar.prototype.handleArrowBottomUp = function() {
            this.checkAndClearArrowHoldInterval();
        };

        SideBar.prototype.checkAndClearArrowHoldInterval = function() {
            if (this.arrowIsHeldDown) {
                clearInterval(this.arrowHoldInterval);
                this.arrowIsHeldDown = false;
            }
        };

        SideBar.prototype.setUpArrowUpdateInterval = function(delta) {
            this.arrowIsHeldDown = true;
            this.updateByArrow(delta);
            this.arrowHoldInterval = setInterval(function() { this.updateByArrow(delta); }.bind(this), 10);
        };

        SideBar.prototype.updateByArrow = function(delta) {
            this.updateScrollPercent(this.currentScrollPercent + delta);
            this.updateHandleByPercent(this.currentScrollPercent);
        };

        return SideBar;

    });

